import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentIndexTypes = ({ location }) => {
  const [contentIndexTypeCodes, setContentIndexTypeCodes] = useState([]);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  let parms = new URLSearchParams(location.search);

  const [state, setState] = useState({
    contentIndexTypeId: parseInt(parms.get("id")),
    contentIndexValueCode: 0,
    contentIndexTypeName: "",
    contentIndexTypeTitle: "",
    contentIndexTypeDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-index-types/${state.contentIndexTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_INDEX_TYPE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypeCodes = res.data;
        console.log("results", contentIndexTypeCodes);
        setContentIndexTypeCodes(contentIndexTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log("handleOnLoad() - loading id = " + state.contentIndexTypeId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-index-types/${state.contentIndexTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };
  function onDelete() {
    let deleteID = state.contentIndexTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-index-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content Index Types </h4>
        <hr />
        <h4>Selector</h4>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Index Type Selector"
          >
            Content Index Type Selector
          </label>
          <select
            id="contentIndexTypeId"
            onchange="submit()"
            className="form-control input-xlarg col-sm-8"
            valueChangeListener="#{ombContentIndexTypeForm.get }"
          >
            <option value="#{ombContentIndexTypeForm.contentIndexTypeSelectList}" />
          </select>
        </div>
        <hr />
        <h4>Content Index Type Details</h4>

        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Index Type Name"
          >
            Content Index Type Name
          </label>
          <input
            id="contentIndexTypeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Index Type Title"
          >
            Content Index Type Title
          </label>
          <input
            id="contentIndexTypeTitle"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeTitle}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Index Value Code"
          >
            Content Index Value Code
          </label>
          <select
            id="contentIndexValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexValueCode}
            onChange={handleChange}
          >
            {/* <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('CONTENT_INDEX_TYPE_CODE')}"/> */}
            <option value={0}>Select Index Value Type</option>
            {contentIndexTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Index Type Description"
          >
            Content Index Type Description
          </label>
          <textarea
            id="contentIndexTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Last Updated By ">
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readOnly={true}
            value={state.lastUpdateUser}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="On">
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readOnly={true}
            type="datetime-local"
            value={state.lastUpdateDate.slice(0, 16)}
            onChange={handleChange}
          ></input>
        </div>

        <hr />
        <div columns="3">
        <button
            className="btn btn-danger"
            value="Delete"
            onClick={onDelete}
          >
            Delete
          </button>
           &nbsp;
          <button className="btn btn-success" value="Save" onClick={handleSave}>
            Save
          </button>
          &nbsp;
         {/* <button
            className="btn btn-primary"
            value="Clear"
            actionListener="#{ombContentIndexTypeForm.clear }"
          >
            Clear
          </button> */}
        </div>
      </div>
    </form>
  );
};

export default ManageContentIndexTypes;
